/**
 * 영상 자료실 (/adm/media)
 * ($j.Pages.Admin.Media / body data-page-name="Media")
 *
 * 사용방법 영상을 올리고 폴더로 정리해, 직원에게 영상 주소(https://media.jbbuller.net/v/<slug>.mp4)를 공유한다.
 * 목록은 서버가 거르고(폴더 · 검색) 정렬하고 50편씩 나눠 준다. 제목 · 메모 · 폴더는 고치면 바로 저장된다.
 *
 * 영상 파일은 웹서버를 거치지 않는다 — 관리자 서버에서 허가 표(ticket)를 받아 브라우저가 영상 서버 /api 로 바로 보낸다.
 *   올리기: upload-ticket → 영상서버 upload/start · chunk(16MB씩) · finish → uploaded(목록에 넣기)
 *   썸네일: poster-ticket → 영상서버 poster → poster-saved
 *   삭제:   delete(목록에서 지우고 표를 받음) → 영상서버 delete
 * 영상서버 호출은 fetch + FormData 다(사전 요청(preflight) 없이 가고, 관리자 화면의 CSRF 헤더를 남의 서버에 보내지 않는다).
 * 길이 · 해상도 · 썸네일은 브라우저가 영상에서 읽는다(video + canvas) — 영상 서버에 ffmpeg 가 없다.
 *
 * 지금 보는 것(폴더 · 검색 · 정렬 · 쪽)은 주소창에 둔다 — 새로고침해도, 주소를 건네도 같은 화면.
 */
export default class Media {
    initialize() {
        const qs = Object.fromEntries(new URLSearchParams(location.search));
        this.S = {folder: qs.folder || '', q: qs.q || '', sort: qs.sort || 'title', page: parseInt(qs.page) || 1};
        this.D = {items: [], folders: [], counts: {all: 0, none: 0}, total: 0, page: 1, pages: 1};
        this.selected = new Set();
        this.loadSeq = 0;
        this.queue = [];
        this.running = false;
        this.qDone = 0;
        this.qFail = 0;
        this.replaceSlug = null;
        this.viewing = null;

        $('#mdQ').val(this.S.q);
        $('#mdSort').val(this.S.sort);
        let qTimer;
        $('#mdQ').on('input', () => {
            clearTimeout(qTimer);
            qTimer = setTimeout(() => { this.S.q = $('#mdQ').val().trim(); this.S.page = 1; this.selected.clear(); this.load(); }, 250);
        });
        $('#mdSort').on('change', () => { this.S.sort = $('#mdSort').val(); this.S.page = 1; this.load(); });

        this._bindFolders();
        this._bindList();
        this._bindSelection();
        this._bindViewer();
        this._bindUpload();
        this.load();
    }

    // ── 서버 ────────────────────────────────────────────
    async _post(url, data) {
        const res = await $.ajax({url, type: 'post', dataType: 'json', data});
        if (!res.ok) throw new Error(res.message || '실패했습니다.');
        return res;
    }

    /** 영상 서버 /api — 허가 표를 FormData 에 실어 보낸다 */
    async _media(server, path, fields) {
        const fd = new FormData();
        Object.entries(fields).forEach(([k, v]) => v instanceof Blob ? fd.append(k, v, k === 'poster' ? 'poster.jpg' : 'chunk') : fd.append(k, v));
        const r = await fetch(server + '/api' + path, {method: 'POST', body: fd});
        let j = null;
        try { j = await r.json(); } catch (e) {}
        if (!r.ok || !j || j.ok === false) throw new Error((j && j.message) || `영상 서버 오류 (${r.status})`);
        return j;
    }

    _fail(err) {
        $j.Ui.Toast.show(err.message || err.responseJSON?.message || '실패했습니다.', {type: 'error'});
    }

    _toast(msg) {
        $j.Ui.Toast.show(msg, {type: 'success'});
    }

    async load() {
        const seq = ++this.loadSeq;
        const S = this.S;
        const keep = Object.entries(S).filter(([k, v]) => v !== '' && !(k === 'page' && v === 1) && !(k === 'sort' && v === 'title'));
        history.replaceState(null, '', location.pathname + (keep.length ? '?' + new URLSearchParams(keep) : ''));
        try {
            const res = await $.ajax({url: '/adm/ajax/media/list', type: 'get', dataType: 'json', data: S});
            if (seq !== this.loadSeq) return;                                   // 늦게 온 옛 검색 결과는 버린다
            this.D = res;
            this.S.page = res.page;
            this._drawFolders();
            this._drawList();
        } catch (err) { this._fail(err); }
    }

    // ── 폴더 ────────────────────────────────────────────
    _folderName(num) {
        if (num === null || num === undefined || num === '' || num === 'none') return '미분류';
        return (this.D.folders.find(f => f.num === +num) || {}).name || '?';
    }

    _drawFolders() {
        const esc = this._esc;
        const row = (key, name, n, edit) => `<div class="md-fd${String(this.S.folder) === String(key) ? ' on' : ''}" data-folder="${key}">
            <span class="md-fd-nm">${esc(name)}</span><span class="md-fd-ct">${n}</span>
            ${edit ? '<button type="button" class="md-fd-ed" data-fd="rename" title="이름 바꾸기"><i class="fas fa-pen"></i></button><button type="button" class="md-fd-ed" data-fd="del" title="폴더 지우기 (영상은 미분류로)"><i class="fas fa-times"></i></button>' : ''}</div>`;
        $('#mdFolders').html(row('', '전체', this.D.counts.all) + row('none', '미분류', this.D.counts.none)
            + '<div class="md-folders-lab">폴더</div>' + this.D.folders.map(f => row(f.num, f.name, f.count, true)).join('')
            + '<button type="button" class="btn btn-outline-secondary btn-sm md-newfd" id="mdNewFolder">+ 새 폴더</button>');
        $('#mdSelMove').html('<option value="">→ 미분류</option>' + this.D.folders.map(f => `<option value="${f.num}">→ ${esc(f.name)}</option>`).join(''));
    }

    _folderInput($el, value, done) {
        $el.html(`<input type="text" class="form-control" maxlength="100" value="${this._esc(value)}">`);
        const $in = $el.find('input').trigger('focus').trigger('select');
        let fin = false;
        const end = (ok) => {
            if (fin) return;
            fin = true;
            const v = $in.val().trim();
            ok && v && v !== value ? done(v) : this._drawFolders();
        };
        $in.on('keydown', (e) => { if (e.key === 'Enter') end(true); if (e.key === 'Escape') end(false); });
        $in.on('blur', () => end(true));
    }

    _bindFolders() {
        $('#mdFolders').on('click', async (e) => {
            if (e.target.id === 'mdNewFolder') {
                const $el = $('<div class="md-fd"></div>').insertBefore(e.target);
                return this._folderInput($el, '', async (name) => {
                    try {
                        const res = await this._post('/adm/ajax/media/folder/save', {name});
                        this._toast(res.message);
                        Object.assign(this.S, {folder: String(res.num), page: 1});
                        this.load();
                    } catch (err) { this._fail(err); this._drawFolders(); }
                });
            }
            const $fd = $(e.target).closest('.md-fd');
            if (!$fd.length || $fd.find('input').length) return;
            const key = String($fd.data('folder')), f = this.D.folders.find(x => String(x.num) === key);
            const act = $(e.target).closest('[data-fd]').data('fd');
            if (act === 'rename') {
                return this._folderInput($fd, f.name, async (name) => {
                    try { this._toast((await this._post('/adm/ajax/media/folder/save', {num: f.num, name})).message); this.load(); }
                    catch (err) { this._fail(err); this._drawFolders(); }
                });
            }
            if (act === 'del') {
                if (!await $j.Ui.Dialog.confirm(`「${f.name}」 폴더를 지울까요?\n든 영상 ${f.count}편은 지워지지 않고 미분류로 옮겨집니다.`)) return;
                try { this._toast((await this._post('/adm/ajax/media/folder/delete', {num: f.num})).message); Object.assign(this.S, {folder: '', page: 1}); this.load(); }
                catch (err) { this._fail(err); }
                return;
            }
            Object.assign(this.S, {folder: key, page: 1});
            this.selected.clear();
            this.load();
        });

        // 줄을 끌어다 폴더에 놓으면 옮긴다 (고른 줄이 있으면 고른 것 전부)
        const target = (e) => {
            const fd = e.target.closest('.md-fd[data-folder]');
            return fd && fd.dataset.folder !== '' && e.originalEvent.dataTransfer.types.includes('text/x-slugs') ? fd : null;
        };
        $('#mdFolders')
            .on('dragover', (e) => {
                const fd = target(e);
                if (!fd) return;
                e.preventDefault();
                $('.md-fd.drop-on').removeClass('drop-on');
                fd.classList.add('drop-on');
            })
            .on('dragleave', (e) => $(e.target).closest('.md-fd').removeClass('drop-on'))
            .on('drop', (e) => {
                const fd = target(e);
                if (!fd) return;
                e.preventDefault();
                fd.classList.remove('drop-on');
                const slugs = JSON.parse(e.originalEvent.dataTransfer.getData('text/x-slugs') || '[]');
                if (slugs.length) this._moveTo(slugs, fd.dataset.folder === 'none' ? '' : fd.dataset.folder);
            });
    }

    async _moveTo(slugs, folder) {
        try {
            this._toast((await this._post('/adm/ajax/media/move', {slugs, folder})).message);
            this.selected.clear();
            this.load();
        } catch (err) { this._fail(err); }
    }

    // ── 목록 ────────────────────────────────────────────
    _drawList() {
        const D = this.D, esc = this._esc;
        $('#mdTotal').text(`${D.total.toLocaleString()}편` + (D.pages > 1 ? ` · ${D.page}/${D.pages}쪽` : ''));
        if (!D.items.length) {
            $('#mdList').html(`<div class="md-empty">${this.S.q ? '찾는 영상이 없습니다.' : '영상이 없습니다. [영상 올리기]를 누르거나 mp4 파일을 이 창에 끌어다 놓으세요.'}</div>`);
        } else {
            const opts = '<option value="">미분류</option>' + D.folders.map(f => `<option value="${f.num}">${esc(f.name)}</option>`).join('');
            $('#mdList').html(`<table class="md-table"><thead><tr>
                <th class="md-ck"><input type="checkbox" id="mdCkAll"></th><th></th><th>제목 · 메모</th>
                <th class="md-hide">폴더</th><th class="md-hide">길이</th><th class="md-hide">크기</th><th class="md-hide">올린 날 · 사람</th><th></th>
              </tr></thead><tbody>${D.items.map(v => `
              <tr data-slug="${esc(v.slug)}" draggable="true" class="${this.selected.has(v.slug) ? 'sel' : ''}">
                <td class="md-ck"><input type="checkbox" data-ck ${this.selected.has(v.slug) ? 'checked' : ''}></td>
                <td class="md-th">${v.poster ? `<img class="md-thumb" src="${esc(v.poster)}" loading="lazy" decoding="async" alt="" data-act="view">` : '<div class="md-thumb" data-act="view"></div>'}</td>
                <td><div class="md-ttl">
                  <input type="text" class="md-t" data-f="title" value="${esc(v.title)}" maxlength="200" title="눌러서 고치면 바로 저장됩니다">
                  <input type="text" class="md-m" data-f="memo" value="${esc(v.memo)}" maxlength="5000" placeholder="메모 (관리용 — 직원에게는 안 보입니다)">
                  <span class="md-url">${esc(v.url)}${v.orig_name ? ' · ' + esc(v.orig_name) : ''}</span></div></td>
                <td class="md-fdc md-hide"><select class="form-control form-control-sm" data-f="folder">${opts}</select></td>
                <td class="md-num md-hide">${this._mmss(v.duration)}<br>${v.w}×${v.h}</td>
                <td class="md-num md-hide">${this._mb(v.size)}</td>
                <td class="md-num md-hide">${esc((v.created_at || '').slice(0, 10))}<br>${esc(v.uploader || '-')}</td>
                <td class="md-act"><button type="button" class="btn btn-primary btn-xs" data-act="copy">주소 복사</button><button type="button" class="btn btn-outline-secondary btn-xs" data-act="view">보기</button><button type="button" class="btn btn-outline-secondary btn-xs" data-act="replace" title="주소 · 제목은 그대로 두고 영상 파일만 바꿉니다">교체</button><button type="button" class="btn btn-outline-danger btn-xs" data-act="del">삭제</button></td>
              </tr>`).join('')}</tbody></table>`);
            D.items.forEach(v => $(`#mdList tr[data-slug="${v.slug}"] select`).val(v.folder ?? ''));
        }
        this._drawPager();
        this._drawSel();
    }

    _drawPager() {
        const n = this.D.pages, p = this.D.page;
        if (n <= 1) return $('#mdPager').empty();
        const pages = [...new Set([1, p - 2, p - 1, p, p + 1, p + 2, n])].filter(x => x >= 1 && x <= n).sort((a, b) => a - b);
        let out = `<button type="button" class="btn btn-outline-secondary btn-sm" data-page="${p - 1}" ${p > 1 ? '' : 'disabled'}>‹</button>`, prev = 0;
        for (const x of pages) {
            if (x - prev > 1) out += '<span class="md-total">…</span>';
            out += `<button type="button" class="btn btn-outline-secondary btn-sm${x === p ? ' on' : ''}" data-page="${x}">${x}</button>`;
            prev = x;
        }
        $('#mdPager').html(out + `<button type="button" class="btn btn-outline-secondary btn-sm" data-page="${p + 1}" ${p < n ? '' : 'disabled'}>›</button>`);
    }

    _item(slug) { return this.D.items.find(v => v.slug === slug); }

    _replaceItem(v) {
        const i = this.D.items.findIndex(x => x.slug === v.slug);
        if (i >= 0) this.D.items[i] = v;
    }

    _bindList() {
        $('#mdPager').on('click', '[data-page]', (e) => {
            if (e.currentTarget.disabled) return;
            this.S.page = +e.currentTarget.dataset.page;
            this.load().then(() => window.scrollTo(0, 0));
        });

        // 칸을 고치면 바로 저장
        $('#mdList').on('change', async (e) => {
            const tr = e.target.closest('tr[data-slug]');
            if (!tr) return;
            const slug = tr.dataset.slug;
            if (e.target.dataset.ck !== undefined) {
                e.target.checked ? this.selected.add(slug) : this.selected.delete(slug);
                tr.classList.toggle('sel', e.target.checked);
                return this._drawSel();
            }
            const field = e.target.dataset.f;
            if (!field) return;
            try {
                const res = await this._post('/adm/ajax/media/update', {slug, field, value: e.target.value});
                this._replaceItem(res.item);
                this.D.folders = res.folders;
                this.D.counts = res.counts;
                this._drawFolders();
                $(e.target).addClass('md-saved');
                setTimeout(() => $(e.target).removeClass('md-saved'), 900);
                if (field === 'folder' && this.S.folder !== '') { this._toast(`「${this._folderName(res.item.folder)}」로 옮겼습니다.`); this.load(); }
            } catch (err) {
                this._fail(err);
                if (field === 'title') e.target.value = this._item(slug).title;
            }
        });
        $('#mdList').on('keydown', 'input[data-f]', (e) => { if (e.key === 'Enter') e.target.blur(); });

        $('#mdList').on('click', async (e) => {
            if (e.target.id === 'mdCkAll') {
                this.D.items.forEach(v => e.target.checked ? this.selected.add(v.slug) : this.selected.delete(v.slug));
                return this._drawList();
            }
            const b = e.target.closest('[data-act]');
            if (!b) return;
            const slug = b.closest('tr').dataset.slug, v = this._item(slug);
            switch (b.dataset.act) {
                case 'copy': return this._copy(v.url);
                case 'view': return this._openViewer(v);
                case 'replace':
                    this.replaceSlug = slug;
                    $('#mdReplaceFile').val('').trigger('click');
                    return;
                case 'del':
                    if (!await $j.Ui.Dialog.confirm(`「${v.title}」 영상을 지울까요?\n공유한 주소도 더는 열리지 않습니다. 되돌릴 수 없습니다.`)) return;
                    return this._delete([slug]);
            }
        });

        $('#mdList').on('dragstart', 'tr[data-slug]', (e) => {
            if ($(e.target).is('input, select')) return;
            const slug = e.currentTarget.dataset.slug;
            const slugs = this.selected.has(slug) ? [...this.selected] : [slug];
            e.originalEvent.dataTransfer.setData('text/x-slugs', JSON.stringify(slugs));
            e.originalEvent.dataTransfer.effectAllowed = 'move';
            e.currentTarget.classList.add('dragging');
        }).on('dragend', () => $('#mdList tr.dragging').removeClass('dragging'));
    }

    /** 목록에서 지우고 → 받은 표로 영상 서버 파일을 지운다 */
    async _delete(slugs) {
        try {
            const res = await this._post('/adm/ajax/media/delete', {slugs});
            if (res.ticket) {
                try { await this._media(res.server, '/delete', {ticket: res.ticket}); }
                catch (err) { $j.Ui.Toast.show('목록에서는 지웠지만 영상 서버의 파일은 못 지웠습니다 — ' + err.message, {type: 'warning'}); }
            }
            this._toast(res.message);
            slugs.forEach(s => this.selected.delete(s));
            this.load();
        } catch (err) { this._fail(err); }
    }

    // ── 고른 것 한꺼번에 ─────────────────────────────────
    _drawSel() {
        $('#mdSelBar').prop('hidden', !this.selected.size);
        $('#mdSelN').text(`${this.selected.size}편 선택`);
        $('#mdCkAll').prop('checked', this.D.items.length > 0 && this.D.items.every(v => this.selected.has(v.slug)));
    }

    _bindSelection() {
        $('#mdSelClear').on('click', () => { this.selected.clear(); this._drawList(); });
        $('#mdSelMoveGo').on('click', () => this._moveTo([...this.selected], $('#mdSelMove').val()));
        $('#mdSelCopy').on('click', () => {
            // 이 쪽에 보이는 고른 영상만 — 메신저에 그대로 붙여 넣는 꼴
            const rows = this.D.items.filter(v => this.selected.has(v.slug)).map(v => `${v.title}\n${v.url}`);
            this._copy(rows.join('\n\n'), `${rows.length}편의 제목 · 주소를`);
        });
        $('#mdSelDel').on('click', async () => {
            const n = this.selected.size;
            if (!await $j.Ui.Dialog.confirm(`고른 영상 ${n}편을 지울까요?\n공유한 주소도 더는 열리지 않습니다. 되돌릴 수 없습니다.`)) return;
            this._delete([...this.selected]);
        });
    }

    _copy(text, what = '주소를') {
        (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject())
            .then(() => this._toast(`${what} 복사했습니다` + (text.includes('\n') ? '' : ` — ${text}`)))
            .catch(() => window.prompt('이 내용을 복사하세요', text));
    }

    // ── 보기 · 썸네일 ───────────────────────────────────
    _openViewer(v) {
        this.viewing = v;
        $('#mdVwTitle').text(v.title);
        const video = $('#mdVwVideo')[0];
        video.src = v.play;
        $('#mdViewer').prop('hidden', false);
        video.play().catch(() => {});
    }

    _closeViewer() {
        const video = $('#mdVwVideo')[0];
        video.pause();
        video.removeAttribute('src');
        video.load();
        $('#mdViewer').prop('hidden', true);
    }

    _bindViewer() {
        $('#mdVwClose').on('click', () => this._closeViewer());
        $('#mdViewer').on('click', (e) => { if (e.target.id === 'mdViewer') this._closeViewer(); });
        $(document).on('keydown', (e) => { if (e.key === 'Escape' && !$('#mdViewer').prop('hidden')) this._closeViewer(); });
        $('#mdVwCopy').on('click', () => this._copy(this.viewing.url));
        $('#mdVwPoster').on('click', async () => {
            try {
                const slug = this.viewing.slug;
                const blob = await this._frameOf($('#mdVwVideo')[0], null);
                const t = await this._post('/adm/ajax/media/poster-ticket', {slug});
                await this._media(t.server, '/poster', {ticket: t.ticket, poster: blob});
                const res = await this._post('/adm/ajax/media/poster-saved', {slug});
                this._replaceItem(res.item);
                this._drawList();
                this._toast(res.message);
            } catch (err) { this._fail(err); }
        });
    }

    // ── 영상에서 길이 · 해상도 · 썸네일 읽기 ───────────────
    _frameOf(video, at) {
        return new Promise((res, rej) => {
            const grab = () => {
                const w = video.videoWidth >= video.videoHeight ? 720 : 540, h = Math.round(video.videoHeight * w / video.videoWidth);
                const c = document.createElement('canvas');
                c.width = w;
                c.height = h;
                c.getContext('2d').drawImage(video, 0, 0, w, h);
                c.toBlob(b => b ? res(b) : rej(new Error('썸네일을 만들지 못했습니다')), 'image/jpeg', 0.85);
            };
            if (at === null) return grab();
            video.addEventListener('seeked', grab, {once: true});
            video.currentTime = at;
        });
    }

    _readMeta(file) {
        return new Promise((res, rej) => {
            const v = document.createElement('video'), url = URL.createObjectURL(file);
            v.muted = true;
            v.preload = 'auto';
            v.src = url;
            v.onerror = () => { URL.revokeObjectURL(url); rej(new Error('이 브라우저에서 재생할 수 없는 영상입니다 (mp4 · H.264 로 올려 주세요)')); };
            v.onloadedmetadata = async () => {
                try {
                    const poster = await this._frameOf(v, Math.min(1.6, v.duration / 2));   // 사용방법 영상은 1.6초 무렵이 표지(로고 + 제목)다
                    res({duration: v.duration, w: v.videoWidth, h: v.videoHeight, poster, thumb: URL.createObjectURL(poster)});
                } catch (err) { rej(err); } finally { URL.revokeObjectURL(url); }
            };
        });
    }

    // ── 올리기 — 지금 보고 있는 폴더로(전체 · 미분류를 보고 있으면 미분류) ──
    _targetFolder() {
        return this.S.folder === '' || this.S.folder === 'none' ? '' : this.S.folder;
    }

    _addFiles(list, replace = null) {
        const folder = this._targetFolder();
        for (const file of list) {
            const $el = $(`<div class="md-q"><img alt=""><div><b>${this._esc(file.name)}</b> <span class="md-q-msg">${this._mb(file.size)} · 기다리는 중</span><div class="md-q-pg"><i></i></div></div></div>`);
            $('#mdQueueList').prepend($el);
            this.queue.push({file, $el, replace, folder});
        }
        $('#mdQueue').prop('hidden', false);
        $('#mdQueueClose').prop('hidden', true);
        this._run();
    }

    async _run() {
        if (this.running) return;
        this.running = true;
        while (this.queue.length) {
            const job = this.queue.shift(), $msg = job.$el.find('.md-q-msg'), $bar = job.$el.find('.md-q-pg i');
            $('#mdQueueHead').text(`올리는 중 — 남은 ${this.queue.length + 1}편`);
            try {
                if (!/\.mp4$/i.test(job.file.name)) throw new Error('mp4 파일만 올릴 수 있습니다');
                $msg.text('영상 읽는 중…');
                const meta = await this._readMeta(job.file);
                job.$el.find('img').attr('src', meta.thumb);
                const t = await this._post('/adm/ajax/media/upload-ticket', {replace: job.replace || ''});
                const {id, chunk} = await this._media(t.server, '/upload/start', {ticket: t.ticket});
                for (let off = 0; off < job.file.size; off += chunk) {
                    for (let tries = 1; ; tries++) {
                        try {
                            await this._media(t.server, '/upload/chunk', {ticket: t.ticket, id, offset: off, chunk: job.file.slice(off, off + chunk)});
                            break;
                        } catch (err) {
                            if (tries >= 3) throw err;
                            await new Promise(r => setTimeout(r, 1500 * tries));   // 잠깐 끊긴 것은 다시 보낸다
                        }
                    }
                    const done = Math.min(job.file.size, off + chunk);
                    $bar.css('width', (done / job.file.size * 100).toFixed(1) + '%');
                    $msg.text(`올리는 중 ${this._mb(done)} / ${this._mb(job.file.size)}`);
                }
                const fin = await this._media(t.server, '/upload/finish', {ticket: t.ticket, id, poster: meta.poster});
                const title = job.file.name.replace(/\.mp4$/i, '').replace(/^장비불러_(사용방법_)?/, '').replace(/_/g, ' ');
                const res = await this._post('/adm/ajax/media/uploaded', {
                    slug: t.slug, replace: job.replace ? 1 : 0, title, folder: job.folder, orig_name: job.file.name,
                    size: fin.size, duration: meta.duration.toFixed(1), w: meta.w, h: meta.h, poster: 1,
                });
                job.$el.addClass('done');
                $msg.text((job.replace ? '바꿨습니다' : `올렸습니다 → ${this._folderName(job.folder)}`) + ` · ${res.item.url}`);
                this.qDone++;
                this.load();
            } catch (err) {
                job.$el.addClass('fail');
                $msg.text(err.message || err.responseJSON?.message || '실패했습니다');
                this.qFail++;
            }
        }
        this.running = false;
        $('#mdQueueHead').text(`다 올렸습니다 — ${this.qDone}편` + (this.qFail ? ` · 실패 ${this.qFail}편` : ''));
        $('#mdQueueClose').prop('hidden', false);
    }

    _bindUpload() {
        $('#mdQueueClose').on('click', () => {
            $('#mdQueue').prop('hidden', true);
            $('#mdQueueList').empty();
            this.qDone = this.qFail = 0;
        });
        $('#mdFiles').on('change', (e) => { this._addFiles([...e.target.files]); e.target.value = ''; });
        $('#mdReplaceFile').on('change', (e) => { if (e.target.files[0] && this.replaceSlug) this._addFiles([e.target.files[0]], this.replaceSlug); });
        window.addEventListener('beforeunload', (e) => { if (this.running) { e.preventDefault(); e.returnValue = ''; } });

        // 창 어디든 파일을 끌어다 놓으면 올린다
        let depth = 0;
        const isFiles = (e) => e.dataTransfer && [...e.dataTransfer.types].includes('Files');
        window.addEventListener('dragenter', (e) => {
            if (!isFiles(e)) return;
            depth++;
            $('#mdDropMsg').text(`놓으면 「${this._folderName(this._targetFolder())}」에 올립니다`);
            $('#mdDropzone').prop('hidden', false);
        });
        window.addEventListener('dragleave', (e) => { if (isFiles(e) && --depth <= 0) { depth = 0; $('#mdDropzone').prop('hidden', true); } });
        window.addEventListener('dragover', (e) => { if (isFiles(e)) e.preventDefault(); });
        window.addEventListener('drop', (e) => {
            if (!isFiles(e)) return;
            e.preventDefault();
            depth = 0;
            $('#mdDropzone').prop('hidden', true);
            this._addFiles([...e.dataTransfer.files]);
        });
    }

    // ── 글자 ────────────────────────────────────────────
    _esc(s) {
        return String(s ?? '').replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
    }

    _mmss(s) {
        return `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}`;
    }

    _mb(b) {
        return (b / 1048576).toFixed(1) + 'MB';
    }
}
